<div class="d-flex justify-content-center w-100">
    <p class="text-success row-green w-50 text-center" style="font-size: 1rem; padding: 1rem; border-radius: 0.5rem">
        <strong>
            Historial
        </strong>
        <a class="stretched-link text-success" style="text-decoration-line: underline; cursor: pointer"
            (click)="showHistory=!showHistory">{{!showHistory ? 'Ver historial' : 'Ocultar historial'}}</a>
    </p> <br>
</div>
<div *ngIf="showHistory" class="w-100">
    <app-list entityName="PpyeIncomeHistory" module="MovimientoBienes"
        [dataEntity]="{enableAdd: false, customTitle: 'Historial'}"
        [defaultQuery]="[{column:'ppyeIncome', value: item._id }]"></app-list>
</div>
<ng-container *ngIf="!openForm">
    <div class="assets-total-summary" *ngIf="ppyeIncome">
        <div class="assets-total-icon" aria-hidden="true">
            <mat-icon>account_balance_wallet</mat-icon>
        </div>
        <div class="assets-total-details">
            <span class="assets-total-label">Total bienes asociados</span>
            <span class="assets-total-caption">Valor acumulado de los activos registrados</span>
        </div>
        <strong class="assets-total-value">{{ format(totalAsset) }}</strong>
        <div class="assets-total-available">
            <span>Disponible</span>
            <strong>{{ format(availableBalance) }}</strong>
        </div>
    </div>
    <app-list #assets entityName="ActivoFijo" module="MovimientoBienes" group="GS" (loadedData)="getTotalAsset()"
        [dataEntity]="{enableAdd: false, customTitle: 'Bienes Asociados', itemsPerPage:500}"
        [defaultQuery]="[{column:'ppyeIncome', value: item._id }]" 
        [groupColumn]="group === 'DOTACION' ? 'descripcion' : null">
        <div class="actionsTable">
            <button mat-raised-button
                *ngIf="!block && canAdd && (item.state === 'I' || item.state === 'R') && availableBalance != 0"
                matTooltip="Agregar Bienes" color="primary" (click)="addItem()" [disabled]="isLoading">
                <mat-icon>add</mat-icon>
                Agregar Bienes
            </button>
            <button mat-raised-button
                *ngIf="!block && canAdd && (item.state === 'I' || item.state === 'R') && availableBalance == 0"
                matTooltip="Solicitar Aprobación" color="primary" (click)="request()" [disabled]="isLoading">
                Solicitar Aprobación
            </button>
            <button mat-raised-button
                *ngIf="!block && canAdd && item.state === 'A' && availableBalance == 0 && !certificateId"
                matTooltip="Generar Recibido Satisfacción" color="primary" (click)="generateCertificate()"
                [disabled]="isLoading">
                Generar Recibido Satisfacción
            </button>
        </div>
    </app-list>
    <app-list *ngIf="certificateId" entityName="CertificatesAsset" module="MovimientoBienes" group="GV"
        [dataEntity]="{enableAdd: false, customTitle: 'Acta Recibido Satisfacción', exportableDocs:false, group: 'GV', displayGroup: 'GV'}"
        [defaultQuery]="[{column:'id', value: certificateId }]">
    </app-list>
</ng-container>
<ng-container *ngIf="!block && canAdd && openForm">
<div class="assets-total-summary" *ngIf="ppyeIncome">
            <div class="assets-total-icon" aria-hidden="true">
                <mat-icon>account_balance_wallet</mat-icon>
            </div>
            <div class="assets-total-details">
                <span class="assets-total-label">Total bienes asociados</span>
                <span class="assets-total-caption">Valor acumulado de los activos registrados</span>
            </div>
            <strong class="assets-total-value">{{ format(totalAsset) }}</strong>
            <div class="assets-total-available">
                <span>Disponible</span>
                <strong>{{ format(availableBalance)  }}</strong>
            </div>
        </div>
    <app-assets-entry-form (close)="close()" [origin]="group" [item]="item"
        [maxValue]="availableBalance"></app-assets-entry-form>
</ng-container>